export default function customersDirective() {
  return {
    template: require('./customers.html'),
    scope: {
      user: '=',
      customers: '=',
    },
    controller: 'UACustomersController',
    controllerAs: 'customersVM',
    bindToController: true,
    replace: true,
  };
}
